export enum ButtonType {
  InsertTags = 'InsertTags',
  ResetToDefault = 'ResetToDefault',
  SendTestEmail = 'SendTestEmail',
}
